export default {"src":"/_next/static/media/joinNowBg.98e3f358.svg","height":362,"width":1440};